<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
  <augment-product-carousel
    v-if="productList.length > 0"
    :carousel-identifier="carouselId"
    :enable-navigation="smallScreen"
  >
    <div
      v-for="(product, index) in productList"
      :key="index"
      :slot="`product${index + 1}`"
      class="routine-product"
      :data-tagging-on-impression="JSON.stringify(product.tagging_impression)"
    >
      <div class="routinehover-item">
        <div class="routine routine-scale">
          <div class="diagnostic-product-number" style="left: 3%; bottom: 18%; font-size: 195%">
            {{ product.stepNumber }}
          </div>
          <div class="diagnostic-product-title" style="bottom: 25%; left: 13%; font-size: 20%">
            {{ product.stepLabel }}
          </div>
          <img class="" :src="product.productFirstImage.Src" :alt="product.productFirstImage.Alt" />
        </div>
        <h3 v-if="product.title">{{ product.title }}</h3>
        <p>{{ product.summary }}</p>
        <a
          v-if="buttonText"
          class="product-button-link"
          @click="diagnosticLearnTagging(product.tagging_click, product.url)"
          >{{ buttonText }}</a
        >
      </div>
    </div>
  </augment-product-carousel>
</template>
<script>
export default {
  name: 'recommended-product-list',
  props: {
    productList: { type: Array, required: true },
    buttonText: { type: String, required: true },
  },
  data() {
    return {
      actions: {
        next: 'next',
        previous: 'previous',
        select: 'display',
      },
      smallScreen: window.ScreenSizeHandler
        ? window.ScreenSizeHandler.getMqForSize('small').selected
        : true,
    };
  },
  mounted() {
    // NOSONAR
    window.eventBus.$on('fireOnClick', (page) => {
      this.fireTaggingOnClick(page);
    });
    if (this.productList && this.productList.length) {
      const impressions = [];
      let productTaggingDetails;
      this.productList.forEach((taggingItem) => {
        const { ecommerce } = taggingItem.tagging_impression;
        if (Object.keys(ecommerce).length > 0) {
          productTaggingDetails = ecommerce.impressions[0];
          impressions.push({
            name: productTaggingDetails.name || 'none',
            id: productTaggingDetails.id,
            price: productTaggingDetails.price || 'none',
            brand: productTaggingDetails.brand || 'none',
            category: productTaggingDetails.category || 'none',
            list: productTaggingDetails.list || 'none',
            position: productTaggingDetails.position || '0',
            dimension35: productTaggingDetails.dimension35 || 'none',
            dimension38: productTaggingDetails.dimension38 || 'none',
            dimension48: productTaggingDetails.dimension48 || 'none',
            dimension91: productTaggingDetails.dimension91 || 'none',
          });
        }
      });
      try {
        if (impressions && impressions.length) {
          dataLayer.push({
            event: 'nievent',
            event_name: 'view_item_list',
            eventCategory: 'Ecommerce',
            eventAction: 'Product Impressions',
            eventLabel: 'content page::augmented products',
            ecommerce: {
              currencyCode: 'none',
              impressions: impressions,
            },
          });
        }
      } catch {
        console.warn('datalayer is not defined');
      }
    }
  },
  created: function () {
    dataLayer.push({
      event: 'nievent',
      ecommerce: 'undefined',
      eventCategory: 'augmented products',
      eventAction: `diagnosis::see recommended routine`,
      eventLabel: '',
    });
  },
  methods: {
    fireTaggingOnClick(slide) {
      const tagging = JSON.parse(JSON.stringify(this.productList[slide].tagging_augmented_product));
      const { event, eventLabel, eventAction, eventCategory, ecommerce, event_name, product_info } =
        tagging;
      try {
        dataLayer.push({ //eslint-disable-line
          event: event,
          eventCategory: eventCategory,
          eventAction: eventAction,
          eventLabel: eventLabel,
          event_name: event_name,
          product_info: product_info,
          ecommerce: ecommerce,
        });
      } catch {
        console.warn('datalayer is not defined');
      }
    },
    diagnosticLearnTagging(value, url) {
      if (
        value.ecommerce &&
        value.ecommerce.click &&
        value.ecommerce.click.impressions &&
        value.ecommerce.click.impressions.length
      ) {
        const { id, name } = value.ecommerce.click.impressions[0];
        value.ecommerce.click.impressions.forEach((el) => {
          el['dimension35'] = el['dimension35'].split(' ')[0];
          el['variant'] = el['variant'].split(' ')[0];
        });
        dataLayer.push({
          event: 'productClick',
          event_name: 'select_item',
          eventCategory: 'Ecommerce',
          eventAction: 'Product Click',
          eventLabel: [name.toLowerCase().trim()] + '::' + [id],
          product_info: [name.toLowerCase().trim()] + '::' + [id],
          ecommerce: value.ecommerce,
        });
      } else if (
        value.ecommerce &&
        value.ecommerce.click &&
        value.ecommerce.click.products &&
        value.ecommerce.click.products.length
      ) {
        const { id, name } = value.ecommerce.click.products[0];
        value.ecommerce.click.products.forEach((el) => {
          el['dimension35'] = el['dimension35'].split(' ')[0];
          el['variant'] = el['variant'].split(' ')[0];
        });
        dataLayer.push({
          event: 'productClick',
          event_name: 'select_item',
          eventCategory: 'Ecommerce',
          eventAction: 'Product Click',
          eventLabel: [name.toLowerCase().trim()] + '::' + [id],
          product_info: [name.toLowerCase().trim()] + '::' + [id],
          ecommerce: value.ecommerce,
        });
      }
      window.location.href = url;
    },
  },
};
</script>
